import { render, staticRenderFns } from "./Anas.vue?vue&type=template&id=362c1972&scoped=true"
import script from "./Anas.vue?vue&type=script&lang=js"
export * from "./Anas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c1972",
  null
  
)

export default component.exports